////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const logExtranet = {
	postLogExtranet: (filters = {}, queryParams = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_LOG_EXTRANET,
		payload: {
			filters,
			queryParams,
		},
	}),
	postLogExtranetSuccess: (data) => ({
		type: ActionsTypes.POST_LOG_EXTRANET_SUCCESS,
		payload: { data },
	}),
	postLogExtranetFailure: () => ({
		type: ActionsTypes.POST_LOG_EXTRANET_FAILURE,
		payload: {},
	}),

	resetLogExtranet: () => ({
		type: ActionsTypes.RESET_LOG_EXTRANET,
	}),
}

export default logExtranet
